import React from 'react'

export const ProgressBarStyles: { [key: string]: React.CSSProperties } = {
    container: {
        width: '100%',
        minWidth: 400,
    },
    content: {
        height: 20,
        width: '100%',
        borderRadius: 10,
        overflow: 'hidden',
        position: 'relative',
        backgroundColor: '#E0E6ED',
    },
    progress: {
        width: '0%',
        float: 'left',
        height: '100%',
        backgroundColor: '#4361EE',
        backgroundSize: '20px 20px',
        transition: 'width .6s ease',
        borderRadius: 10,
        backgroundImage:
            'linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent)',
    },
}
